/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Footer_GuidesInputs */

const en_control_footer_guides = /** @type {(inputs: Control_Footer_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides`)
};

const zh_control_footer_guides = /** @type {(inputs: Control_Footer_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`攻略`)
};

/**
* | output |
* | --- |
* | "Guides" |
*
* @param {Control_Footer_GuidesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_footer_guides = /** @type {((inputs?: Control_Footer_GuidesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Footer_GuidesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_footer_guides(inputs)
	return zh_control_footer_guides(inputs)
});
export { control_footer_guides as "control.footer.guides" }